import script from "./searchFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./searchFilter.vue?vue&type=script&setup=true&lang=js"

import "./searchFilter.vue?vue&type=style&index=0&id=61803762&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61803762"]])

export default __exports__